<template>
  <div id="footer">
    
    <div class="footer4">
      <div class="contentWidth">
        <span style="display: flex;align-items: center;justify-content: center; ">
          北京数聚智连科技股份有限公司版权所有 <span style="cursor:pointer;" @click="beian">© 2019京ICP备16050841号</span>
          <a target="_blank" 
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502038844" 
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left:40px;display: inline-flex;align-items: center;">
          <img src="../assets/img/gb231.png"/>
          <span style="height:80px;line-height:80px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010502038844号</span >
          </a>
  
        </span>
        
        
<!-- <div style="width:300px;margin:0 auto; padding:20px 0;">
  <a target="_blank" 
  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502038844" 
  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
  <img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010502038844号</p ></a>
</div> -->

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer1',
  data () {
    return {
    }
  },
  methods:{
    beian(){
      window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
@import '../assets/css/norm.less';
#footer{
  display: block;
  background: #fff;
  
  .footer4{
    display: block;
    width: 100%;
    height: 80px;
    position: relative;
    box-sizing: border-box;
    /*box-shadow: 0 0 10px rgba(0,0,0,0.1);*/
    div{
      text-align: center !important;
    }
  }
  .footer4>div>span{
    font-size: 12px;
    line-height: 80px;
    float: left;
    width: 100%;
    color: #828282;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue